export default __webpack_public_path__ + "static/banner-and-8ae0a6a38f4955bc590e6628b20056b4.webp";